import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { denteTipoFace } from "../../Constants";
import FieldTitle from "../../Components/FieldTitle";
import CheckboxFaces from "../../Components/CheckboxFaces";
import ButtonLong from "../../../../../../components/Button/ButtonLong";
import { TextFieldSearch } from "../../../../../../components/TextField";
import { ReactSelect } from "../../../../../../components/Select/SelectSearch";
import { findAllLocalOdontograma } from "../../../../../../services/OdontogramaService";
import Input from "../../../../../../components/Input/Input";

const Informacoes = observer(({ classes, odontogramaStore }) => {
  const { modalEditarProcedimento, odontograma } = odontogramaStore;

  const {
    procedimentoOdontologicoSelecionado,
    isDuplicarProcedimento,
  } = modalEditarProcedimento;

  const {
    localSelecionado,
    procedimento,
    quantidadeAgendamentos,
  } = procedimentoOdontologicoSelecionado;

  const [locais, setLocais] = useState([]);
  const [filterLocal, setFilterLocal] = useState({});
  const [loadingSave, setLoadingSave] = useState(false);

  const isDente = localSelecionado?.local === 4;

  useEffect(() => {
    loadLocalOdontograma();
  }, [filterLocal]);

  const loadLocalOdontograma = async () => {
    try {
      const response = await findAllLocalOdontograma({
        odontogramaId: odontograma?.id,
        localOdontograma: localSelecionado?.local,
      });

      setLocais(response);
    } catch (e) {
      console.error(e);
    }
  };

  const handleLoadMoreOptions = async (search, loadedOptions, { page }) => {
    try {
      let pageableDTO = {
        pageNumber: page,
        pageSize: 30,
        sortDir: "ASC",
        sortField: "nome",
      };

      const response = await odontogramaStore.loadProcedimentoOdontologicoSelect(
        {
          search,
          localOdontograma: {
            id: localSelecionado.localOdontograma.id,
            tipo: localSelecionado?.localOdontograma?.tipo,
          },
          pageableDTO,
        }
      );

      const { content, last } = response;

      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch (e) {
      console.error(e);
    }
  };

  const handleChange = (value, field) => {
    try {
      setFilterLocal(value);

      if (field === "procedimento") {
        odontogramaStore.modalEditarProcedimento.procedimentoOdontologicoSelecionado.localSelecionado = null;
      }

      if (field === "quantidadeAgendamentos") {
        return odontogramaStore.modalEditarProcedimento.procedimentoOdontologicoSelecionado.quantidadeAgendamentos = value
      
      }

      const dentesTipoFace = value.local === 4 && denteTipoFace;

      odontogramaStore.modalEditarProcedimento.procedimentoOdontologicoSelecionado[
        field
      ] = {
        ...value,
        denteTipoFace: dentesTipoFace,
      };
    } catch (e) {
      console.error("Ocorreu este erro:", e);
    }
  };

  const handleCheckFace = (posicao, tipoFace, posicaoFace) => {
    const dentesTipoFace = localSelecionado.denteTipoFace.map((item, index) => {
      const tipoFaceAlteraChecked = {
        ...item,
        checked: !tipoFace?.checked,
      };
      const local = index === posicaoFace ? tipoFaceAlteraChecked : item;

      return local;
    });

    odontogramaStore.modalEditarProcedimento.procedimentoOdontologicoSelecionado.localSelecionado = {
      ...localSelecionado,
      denteTipoFace: dentesTipoFace,
    };
  };

  const handleSave = async () => {
    try {
      setLoadingSave(true);

      if (!localSelecionado) {
        odontogramaStore.openNotification("Favor selecionar um local", "error");

        return;
      }
      const tipo = isDente ? "dente" : "mucosaOral";

      const face =
        isDente &&
        localSelecionado.denteTipoFace
          .filter((item) => item.checked)
          .map((item) => item.value);

      const procedimentoOdontologico = {
        id: procedimentoOdontologicoSelecionado.id,
        tuss22ProcedimentoEventoSaude: {
          id:
            procedimentoOdontologicoSelecionado.tuss22ProcedimentoEventoSaude
              .id,
          descricao: procedimento.nome,
        },
        [tipo]: {
          id: localSelecionado.id,
        },
        procedimento: {
          id: procedimento.id,
        },
        face,
        quantidadeAgendamentos,
        status: procedimentoOdontologicoSelecionado?.status
      };

      delete procedimentoOdontologico[tipo].denteTipoFace;
      delete procedimentoOdontologico[tipo].local;
      !isDente && delete procedimentoOdontologico.face;

      isDuplicarProcedimento
        ? await odontogramaStore.createProcedimentoOdontologico(
            procedimentoOdontologico
          )
        : await odontogramaStore.updateProcedimentoOdontologico(
            procedimentoOdontologico
          );

      odontogramaStore.findAllProcedimentoOdontologico();
      odontogramaStore.changeCloseModalEditarProcedimento();
    } catch (e) {
      odontogramaStore.openNotification("Erro ao salvar", "error");
    } finally {
      setLoadingSave(false);
    }
  };

  return (
    <div className={classes.content}>
      <div className={classes.row}>
        <div>
          <FieldTitle title="Procedimento" fontSize={12} />
          <TextFieldSearch
            id="prt-mep-sel-pro"
            placeholder="Selecione aqui"
            loadOptions={handleLoadMoreOptions}
            menuPlacement={"auto"}
            withPaginate
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.id}
            value={procedimento}
            onChange={(e) => handleChange(e, "procedimento")}
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
            classNotched={classes.notchedOutlineSearch}
            classInput={classes.inputSearch}
            isClearable={false}
          />
        </div>
        <div className={classes.fieldLocal}>
          <FieldTitle title="Local" fontSize={12} />
          <ReactSelect
            id="prt-mep-sel-loc"
            value={localSelecionado}
            className={classes.local}
            onChange={(e) => handleChange(e, "localSelecionado")}
            options={locais}
            menuPlacement={"auto"}
            getOptionLabel={(option) =>
              option.local === 4 ? `Dente ${option.codigo}` : option.descricao
            }
            getOptionValue={(option) => option.id}
          />
        </div>
        <div className={classes.fieldLocal}>
          <FieldTitle title="Qnt. Agendamentos" fontSize={12} />
          <Input
            id="prt-mep-inp-qnt"
            value={quantidadeAgendamentos}
            className={classes.input}
            onChange={(e) =>
              handleChange(e.target.value, "quantidadeAgendamentos")
            }
            type="number"
            classes={{
              inputRoot: classes.inputRoot,
            }}
          />
        </div>
      </div>
      {isDente && (
        <CheckboxFaces
          dentesTipoFace={localSelecionado?.denteTipoFace || []}
          handleCheckFace={handleCheckFace}
        />
      )}
      <div className={classes.contentButtons}>
        <ButtonLong
          id="prt-mep-btn-cnc"
          colorCustom="noColor"
          onClick={() => odontogramaStore.changeCloseModalEditarProcedimento()}
          noShadow
          loading={loadingSave}
          disabled={loadingSave}
        >
          Cancelar
        </ButtonLong>
        <ButtonLong
          id="prt-mep-btn-slv"
          colorCustom="green"
          onClick={handleSave}
          noShadow
          loading={loadingSave}
          disabled={loadingSave}
        >
          Salvar
        </ButtonLong>
      </div>
    </div>
  );
});

const styles = {
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    justifyContent: "space-between",
    height: "100%",
    "& svg": {
      fontSize: "14px",
    },
  },
  row: {
    display: "grid",
    gridGap: "10px",
    gridTemplateColumns: "33% 33% 33%",
  },
  fieldLocal: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  local: {
    "&>div>div": {
      border: "1px solid rgba(220, 220, 220, 0.2)",
      borderRadius: "8px",
      height: "32px",
    },
  },
  notchedOutlineSearch: {
    border: "none",
  },
  inputSearch: {
    background: "#F2F2F2",
    border: "0.5px solid rgba(220, 220, 220, 0.2)",
    borderRadius: "8px",
    height: "30px",
    paddingLeft: "8px",
  },
  contentButtons: {
    display: "flex",
    gap: "10px",
    justifyContent: "end",
    marginTop: "12px",
    "& button": {
      maxWidth: "195px",
    },
  },
  input: {
    border: "none",
    height: "100%",
    alignItems: "start",
    padding: "6px",
  },
  inputRoot: {
    background: "#f2f2f2",
    "& svg": {
      display: "none",
    },
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    color: "#000",
  },
};

const InformacoesWithStyles = withStyles(styles)(Informacoes);
export default inject("odontogramaStore")(InformacoesWithStyles);
